import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import Layout from '../../../components/global/layout';
import ApiClient from '../../../methods/api/apiClient';
import loader from '../../../methods/loader';
import './style.scss';
import methodModel from '../../../methods/methods';
import PhoneInput from 'react-phone-input-2';

const SubAdminDetail = (p) => {
  const history = useNavigate();
  const { id, userId } = useParams();
  const [data, setData] = useState();
  const [Permissions, setPermission] = useState({});
  const [phoneNumber, setPhoneNumber] = useState(data?.dialCode + data?.mobileNo || '');

  const getDetail = (did) => {
    loader(true);
    ApiClient.get(`user/detail`, { id: did }).then((res) => {
      if (res.success) {
        setData(res.data);
        console.log(res.data, "gooooooooodmine")
      }
      loader(false);
    });
  };

  const back = () => {
    history(-1);
  };

  useEffect(() => {
    getDetail(userId ? userId : id);
  }, [id, userId]);

  return (
    <Layout>
      <div className="pprofile1 shadow-lg">
        <div className="flex items-center mb-8">
          <button
            type="button"
            class="!px-4 bg-[#fff] py-2 flex items-center justify-center  rounded-lg shadow-btn hover:bg-[#F3F2F5] border  transition-all mr-3"
            to="/users"
            onClick={back}
          >
            <i class="fa fa-angle-left text-lg"></i>
          </button>
          <div>
            <h3 className="text-2xl font-semibold text-[#111827]">View User</h3>
            <p className="text-sm font-normal text-[#525252]">
              Here you can see all about your User
            </p>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Name</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {data && data?.fullName}
            </div>
          </div>
          <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Mobile No.</label>
            {data?.mobileNo ? <PhoneInput
              className="w-full"
              value={data && data?.dialCode + data && data?.mobileNo || ''}
              disableCountryCode
              // minLength={10}

              disabled
            /> :
              <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
                ---
              </div>}
            {/* <div className="pprofiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              ({data && data?.dialCode}) {data && data?.mobileNo}
            </div> */}
          </div>
          <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Email</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {data && data?.email}
            </div>
          </div>
          <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Role</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {data && methodModel.capitalizeFirstLetter(data?.role === "coaches" ? "Coach" : data?.role === "parents" ? "Parent" : data?.role)}
            </div>
          </div>
          {data && data?.bio ? (
            <div className="col-span-12 md:col-span-6">
              <label className="profileheddingcls">Bio</label>
              <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
                {data && methodModel.capitalizeFirstLetter(data?.bio)}
              </div>
            </div>
          ) : null}
          {data?.address ? (
            <div className="col-span-12 md:col-span-6">
              <label className="profileheddingcls">Address</label>
              <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
                {data && data?.address}
              </div>
            </div>
          ) : null}
          {data?.image ? (
            <div className="col-span-12 md:col-span-12">
              <label className="profileheddingcls">Image</label>
              <div>
                <div className="imagethumbWrapper">
                  <img
                    src={methodModel.noImg(data && data?.image, 'users')}
                    className="thumbnail w-[120px] h-[120px] rounded-lg p-1 shadow-md object-contain"
                  />
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </Layout>
  );
};

export default SubAdminDetail;
